import React from "react";


import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import { setAepsSection, setPayTMAepsSection } from "../../redux/aeps/aeps.action";
import { Link } from "react-router-dom";


class AEPSSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }
    componentWillUnmount() {
    }


    merchantAuthenticate = (e) => {
        e.preventDefault();
        store.dispatch(setPayTMAepsSection('merchant-authenticate'))

    }

    showAepsForm = (e) => {
        e.preventDefault();

        store.dispatch(setPayTMAepsSection('aepsForm'))

    }



    render() {

        return (
            <div class={'col-12 col-lg-5 col-xl-4'}>


                <div class="card-b" id="leftdiv">
                    <div class="head">
                        <button type="button" id="aepsbtn" class="dbbtn3 float-right"
                            onClick={this.showAepsForm}>AePS</button>
                        <button type="button" id="aepsbtn" class="dbbtn3 float-right"
                            onClick={this.merchantAuthenticate}>Merchant Authentication</button>
                        <h3>AePS</h3>

                    </div>
                    <div class='valid-success'>
                        Please connect your device before AePS
                    </div>


                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

                    <div class="downloadlink">
                        <h5>Download Driver</h5>
                        <p><a href="https://pbrdms.precisionbiometric.co.in/RDService/index.html" target="_blank">Precision</a> | <a href="https://onlinerdservice.com/morpho-rd-service" target="_blank">Morpho</a> | <a href="https://pbrdms.precisionbiometric.co.in/RDService/index.html" target="_blank">PB510</a></p>
                        <p><a href="https://rdserviceonline.com/" target="_blank">Biometric Device Registration</a> | <a href="https://rdserviceonline.com/">Download User Guide</a></p>
                    </div>
                </div>


            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token }
}
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token
});




export default connect(mapStateToProps, null)(AEPSSearch);
